import React, { FC, useRef } from 'react'

import { Blok } from '@app/typings/blok'
import { useCloseOverlaysOnRouteChange } from '@app/hooks/use-close-overlays-on-route-change'
import { useHeadingNavigation } from '@izettle/public-site-components/dist/help-center'
import { StoryblokComponent } from '@storyblok/react'

type Props = {
  body: Blok[]
}

export const revalidate = 60 * 15 // revalidate this page every 15 minutes

export const Article: FC<Props> = (props) => {
  useCloseOverlaysOnRouteChange()
  const rootElemRef = useRef<HTMLDivElement>(null)
  useHeadingNavigation({ rootElement: rootElemRef, selector: 'h2' })
  return (
    <div className="help-centre-article-body" ref={rootElemRef}>
      {props.body?.map?.((content, index) => {
        const title = (props as Props & { title?: string }).title
        const componentLayout = (content as any)?.layout?.[0]
        const layout = [
          {
            disableWrapperClass: true,
            disableMaximumWidth: true,
            overrideSectionPadding: true,
            ...componentLayout,
          },
        ]

        if (index === 0) {
          return (
            <div key={content._uid} className="first-article-body-component">
              <StoryblokComponent
                blok={content}
                {...{ title, ...content, layout }}
              />
            </div>
          )
        }

        return (
          <StoryblokComponent key={content._uid} blok={content} {...content} />
        )
      })}
    </div>
  )
}
